import type { ReactNode } from 'react';

export interface StaticSummaryProps {
    title: ReactNode;
    description: ReactNode;
    className?: string;
}

const StaticSummary = ({ title, description, className }: StaticSummaryProps) => {
    return (
        <div className={`min-w-40 rounded-lg bg-neutral-50 px-4 py-3 text-center ${className || ''}`}>
            <div className="text-xl font-bold text-neutral-900 lg:text-2xl">{title}</div>
            <div className="text-base font-medium text-neutral-500">{description}</div>
        </div>
    );
};

export default StaticSummary;
